import {
	permissionForLateDataEntryConstants
}from './constants'
import actions from '../../actions'

const initialState =
{
	isSending  : false,
	paged      : null,
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case permissionForLateDataEntryConstants.GetPaged.REQUEST:
		case permissionForLateDataEntryConstants.Create.REQUEST:
		case permissionForLateDataEntryConstants.Delete.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case permissionForLateDataEntryConstants.GetPaged.FAILURE:
		case permissionForLateDataEntryConstants.Create.FAILURE:
		case permissionForLateDataEntryConstants.Delete.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case permissionForLateDataEntryConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case permissionForLateDataEntryConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case permissionForLateDataEntryConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case permissionForLateDataEntryConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : null,
				list       : null,
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}